import { render, staticRenderFns } from "./uplevel-level-stat.vue?vue&type=template&id=c4509870&scoped=true&"
import script from "./uplevel-level-stat.vue?vue&type=script&lang=js&"
export * from "./uplevel-level-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4509870",
  null
  
)

export default component.exports